export default {
    fields: {
        i: '№ п/п',
        action: 'Тип события',
        entityName: 'Тип',
        dateTime: 'Время',
        old: 'Старое значение',
        'new': 'Новое значение',
        userName: 'Инициатор действия',
    },

    orderLog: {
        modal: 'Отправленные данные',
        system: 'Система',
        type: {
            created: 'создано',
            updated: 'обновлено',
            event: 'событие',
        },
    },

    system: 'система',
};